import React from 'react';

import { addDays } from '@ha/date';
import { useFeatureFlags } from 'ha/modules/FeatureFlags';
import { Conversation } from 'ha/services/apiV2/types/Conversation';
import { useCookie } from 'ha/pages/Search/hooks/useCookie';
import base64 from 'ha/utils/base64';

interface BookingLinkHook {
  isEnabled: boolean;
  setBookingLinkCookie: (value?: string) => void;
  removeBookingLinkCookie: () => void;
}

export default function useBookingLink(
  listingId: number,
  conversation?: Pick<Conversation, 'bookingLink'>,
): BookingLinkHook {
  const { bookingLink } = useFeatureFlags();
  const [bookingLinkCookie, updateCookie, removeBookingLinkCookie] = useCookie(
    `bookinglink_${base64.btoa(String(listingId))}`,
  );
  const isEnabled = React.useMemo(
    () =>
      bookingLink === 'on' &&
      (bookingLinkCookie === 'true' || conversation?.bookingLink === true),
    [bookingLink, bookingLinkCookie, conversation],
  );

  const setBookingLinkCookie = React.useCallback(
    (value?: string) => {
      const now = new Date();
      const expires = addDays(now.toString(), 1);

      updateCookie(value || 'true', {
        expires: new Date(expires),
      });
    },
    [updateCookie],
  );

  return {
    isEnabled,
    setBookingLinkCookie,
    removeBookingLinkCookie,
  };
}
